import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface IProps extends PopupProps {
    businessPartnerId: number
    businessPartnerTypeId: number
}

interface BusinessPartnerGroupBusinessPartnerModel {
    businessPartnerGroupId?: number
    businessPartnerId: number
}

const AddBusinessPartnerPopup: React.FC<IProps> = ({ show, onHide, businessPartnerId, businessPartnerTypeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<BusinessPartnerGroupBusinessPartnerModel>({
        businessPartnerId: businessPartnerId,
    });

    const businessPartnerGroups = useSelectListOptions('api/v1/selectlist/businessPartnerGroups?activeOnly=true&businessPartnerTypeId=' + businessPartnerTypeId, '-- Select business partner group');

    function submit() {
        if (formData) {
            DataService
                .create<BusinessPartnerGroupBusinessPartnerModel>(`api/v1/BusinessPartnerGroupBusinessPartners`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'businessPartnerGroupId', label: 'Business partner group', labelSize: 4, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add business-partner group'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('businessPartnerGroupId')} options={businessPartnerGroups} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddBusinessPartnerPopup;